module.exports = __webpack_public_path__ + "static/media/05.3b569bb8.jpg";